import React, { useState, useEffect } from 'react';
import { Table, Input, AutoComplete, Button, Modal, Descriptions, message } from 'antd';
import { Api_VariavelGlobal } from '../global';

const SearchLogsManager = () => {
  const [logs, setLogs] = useState([]);
  const [filteredLogs, setFilteredLogs] = useState([]);
  const [searchValue, setSearchValue] = useState('');
  const [options, setOptions] = useState([]);
  const [selectedLog, setSelectedLog] = useState(null);
  const [isModalVisible, setIsModalVisible] = useState(false);

  const formatarData = (dataISO) => {
    if (!dataISO) return '';
    const data = new Date(dataISO);
    const dia = String(data.getDate()).padStart(2, '0');
    const mes = String(data.getMonth() + 1).padStart(2, '0');
    const ano = data.getFullYear();
    const horas = String(data.getHours()).padStart(2, '0');
    const minutos = String(data.getMinutes()).padStart(2, '0');
    const segundos = String(data.getSeconds()).padStart(2, '0');
    return `${dia}/${mes}/${ano} ${horas}:${minutos}:${segundos}`;
  };

  // Buscar logs
  useEffect(() => {
    const fetchLogs = async () => {
      try {
        const res = await fetch(`${Api_VariavelGlobal}/api/search/search-logs`);
        const data = await res.json();
        const logsArray = Array.isArray(data) ? data : [];
        setLogs(logsArray);
        setFilteredLogs(logsArray);
      } catch (err) {
        console.error('Erro ao buscar logs:', err);
        setLogs([]);
        setFilteredLogs([]);
      }
    };

    fetchLogs();
  }, []);

  // Busca no input
  const handleSearch = (value) => {
    setSearchValue(value);
    const filtered = logs.filter(
      (log) =>
        log.id.toString().includes(value) ||
        (log.query && log.query.toLowerCase().includes(value.toLowerCase()))
    );
    setFilteredLogs(filtered);
    setOptions(
      filtered.map((log) => ({
        value: log.id.toString(),
        label: `ID ${log.id} - ${log.query}`,
      }))
    );
  };

  const onSelect = (value) => {
    setSearchValue(value);
    const filtered = logs.filter((log) => log.id.toString() === value);
    setFilteredLogs(filtered);
  };

  // Mostrar modal
  const showModal = (log) => {
    setSelectedLog(log);
    setIsModalVisible(true);
  };

  const handleCloseModal = () => {
    setSelectedLog(null);
    setIsModalVisible(false);
  };

  // Excluir log
  const handleDelete = async (id) => {
    try {
      await fetch(`${Api_VariavelGlobal}/api/search/search-logs/${id}`, { method: 'DELETE' });
      message.success('Log excluído com sucesso!');
      const updatedLogs = logs.filter((log) => log.id !== id);
      setLogs(updatedLogs);
      setFilteredLogs(updatedLogs);
    } catch (err) {
      console.error('Erro ao excluir log:', err);
      message.error('Erro ao excluir o log.');
    }
  };

  const columns = [
    {
      title: 'ID', dataIndex: 'id', key: 'id', render: (text, record) => (
        <a onClick={() => showModal(record)} style={{ cursor: 'pointer' }}>{text}</a>
      ),
    },
    { title: 'Query', dataIndex: 'query', key: 'query' },
    { title: 'Criado em', dataIndex: 'created_at', key: 'created_at', render: (text) => formatarData(text) },
    {
      title: 'Ações', key: 'acoes', render: (_, record) => (
        <Button type="link" danger onClick={() => handleDelete(record.id)}>Excluir</Button>
      ),
    },
  ];

  return (
    <>
      <AutoComplete
        popupMatchSelectWidth={300}
        style={{ width: 300, marginBottom: 10 }}
        value={searchValue}
        options={options}
        onSelect={onSelect}
        onSearch={handleSearch}
        size="large"
      >
        <Input.Search size="large" placeholder="Buscar por ID ou Query" enterButton />
      </AutoComplete>

      <Table
        columns={columns}
        dataSource={filteredLogs.map(log => ({ ...log, key: log.id }))}
        pagination={{ pageSize: 10 }}
        size="small"
      />

      <Modal
        title={`Detalhes do Log #${selectedLog?.id}`}
        visible={isModalVisible}
        onCancel={handleCloseModal}
        footer={null}
      >
        {selectedLog && (
          <Descriptions column={1} bordered size="small">
            <Descriptions.Item label="ID">{selectedLog.id}</Descriptions.Item>
            <Descriptions.Item label="Query">{selectedLog.query}</Descriptions.Item>
            <Descriptions.Item label="Criado em">{formatarData(selectedLog.created_at)}</Descriptions.Item>
          </Descriptions>
        )}
      </Modal>
    </>
  );
};

export default SearchLogsManager;
